const DELIMITER = '-';
const FRIENDLY_CONVERSATION_ID_REGEX = /^\d+-\d+$/;
export function getFriendlyConversationId(conversation, partnerId) {
    if (!conversation) {
        return '';
    }
    const partnerReadableId = partnerId ?? conversation.partner?.partnerId ?? '';
    const conversationReadableId = conversation.workspaceConversationId?.toString() ?? conversation.conversationId ?? '';
    if (!partnerReadableId) {
        return conversationReadableId;
    }
    return buildFriendlyConversationId(partnerReadableId, conversationReadableId);
}
export function parseFriendlyConversationId(friendlyId) {
    if (!friendlyId || !isFriendlyConversationIdValid(friendlyId)) {
        return {
            partnerId: null,
            workspaceConversationId: '',
        };
    }
    const [partnerId, workspaceConversationId] = friendlyId.split(DELIMITER);
    return {
        partnerId,
        workspaceConversationId,
    };
}
export function buildFriendlyConversationId(partnerId, conversationReadableId) {
    return `${partnerId}${DELIMITER}${conversationReadableId}`;
}
export function isFriendlyConversationIdValid(friendlyId) {
    return !!friendlyId && FRIENDLY_CONVERSATION_ID_REGEX.test(friendlyId);
}
